/**
 * Abrir una descarga del servidor en una pestaña nueva.
 *
 * Parece innecesario —bastaría `window.open`— y no lo es. La sesión de la web
 * va en una cookie que dura quince minutos, y se renueva **de forma reactiva**:
 * cuando una petición del cliente recibe un 401, se renueva y se reintenta.
 *
 * Una pestaña nueva no pasa por ese cliente: es una navegación del navegador.
 * Si la cookie está caducada en ese instante, el usuario recibe un 401 en
 * crudo —un JSON de error donde esperaba su etiqueta— y nada lo renueva.
 *
 * Aquí se hace una petición barata ANTES de abrir. Si la cookie estaba
 * caducada, esa petición la renueva; si no, no cuesta nada. Después se abre,
 * ya con sesión buena.
 */

import type { ApiClient } from './api-client.js';

export async function openDownload(api: ApiClient, path: string): Promise<void> {
  try {
    // Cualquier ruta autenticada vale; ésta es la más barata que hay.
    await api.get('/web/session/me');
  } catch {
    // Si ni renovando hay sesión, se abre igual: el servidor dirá lo que pasa
    // mejor que un mensaje inventado aquí.
  }
  window.open(path, '_blank', 'noopener');
}
